import {
  lockEventListenersTable,
  unlockEventListenersTable,
} from "./helperTable.js";

import {
  menuTag,
  companyRowsValid,
  planRowsValid,
  cropRowsValid,
  sectorRowsValid,
  companyRows,
  planRows,
  cropRows,
  sectorRows,
  fertiProductRowsValid,
  fertiProductRows,
  productRowsValid,
  productRows,
  //clearAll,
  //selectMenu,
} from "./controller.js";

import { renderMenu } from "./shared.js";

import {
  readSupplyTableValues,
  readBasicSupplyTableValues,
  readFertiPlanTableValues,
} from "./controllerPlan.js";

import { headerCrop } from "./model/modelCrops.js";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

//Variables
const btnLogout = document.querySelector(".logout__btn");
let originalCompanyRows,
  originalPlanRows,
  originalCropRows,
  originalSectorRows,
  originalFertiProductRows,
  originalProductRows;

//Exit btn elements
const exitCheckWindow = document.querySelector(".exit-new-plan-window");
const exitModal = document.querySelector(".alert-exit_modal");
const okExitBtn = document.querySelector(".ok-exit__btn");
const notExitBtn = document.querySelector(".not-exit__btn");

export const capitalizeFirstLetter = function (str) {
  return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
};

export const renderCheckExitBtn = function (
  planNav,
  tableWindow,
  window,
  menuTagCurrBtn,
  currentAccount,
) {
  let exitBtn = document.querySelector(".exit-new-plan__btn");
  console.log("exitBtn :", exitBtn);

  if (!exitBtn) {
    renderExitBtn(tableWindow);
    exitBtn = document.querySelector(".exit-new-plan__btn");
  }
  console.log("exitBtn :", exitBtn);
  //const exitBtn = document.querySelector(".exit-new-plan__btn");
  checkExitBtn(
    exitBtn,
    planNav,
    tableWindow,
    window,
    menuTagCurrBtn,
    currentAccount,
  );
};

const renderExitBtn = function (el) {
  const markup = `
                    <button class=" exit-new-plan__btn">
                    <span>Esci</span>
                    </button>
                  `;

  el.insertAdjacentHTML("beforeend", markup);
};

const checkExitBtn = function (
  exitBtn,
  planNav,
  tableWindow,
  window,
  menuTagCurrBtn,
  currentAccount,
) {
  exitBtn.addEventListener("click", function (e) {
    e.preventDefault();

    //Render alert Window
    exitCheckWindow.classList.remove("hidden");
    lockEventListenersTable([planNav, menuTag, tableWindow]);

    //Exit
    okExitBtn.addEventListener("click", function (e) {
      console.log("exit");
      e.preventDefault();

      exitCheckWindow.classList.add("hidden");
      window.innerHTML = "";
      //renderFirstInstructions();
      unlockEventListenersTable([menuTag]);
      menuTagCurrBtn.classList.remove("menu__btn--active");
      btnLogout.classList.remove("no-pointer-events");

      //Remove sidebarMenuBtn and render menuAdd commentMore actions
      //clearAll();
      const sidebarMenuBtn = document.getElementById("sidebar_menu_btn");
      console.log(sidebarMenuBtn);
      sidebarMenuBtn.remove();
      renderMenu();
      //selectMenu(currentAccount);
    });

    //Not exit
    notExitBtn.addEventListener("click", function (e) {
      console.log("not exit");
      e.preventDefault();
      exitCheckWindow.classList.add("hidden");

      unlockEventListenersTable([tableWindow]);
    });

    //Modal Btn
    exitModal.addEventListener("click", function (e) {
      console.log("modal exit");
      e.preventDefault();
      exitCheckWindow.classList.add("hidden");

      unlockEventListenersTable([tableWindow]);
    });
  });
};

export const updateNewPlanUI = function (
  newPlanMenuBtns,
  activeBtn,
  newPlanTableWindow,
  lockArray,
) {
  updateMenuBtnActive(activeBtn, newPlanMenuBtns);

  newPlanTableWindow.innerHTML = "";
  lockEventListenersTable(lockArray);
};

const updateMenuBtnActive = function (activeBtn, newPlanMenuBtns) {
  newPlanMenuBtns.forEach((btn) =>
    btn.classList.remove("new-plan__btn--active"),
  );
  activeBtn.classList.add("new-plan__btn--active");
};

export const renderCheckContinueBtn = function (window, typeInput) {
  renderContinueBtn(window);
  const continueBtn = document.querySelector(".upload-supply-input__btn");
  checkContinueBtn(continueBtn, typeInput);
};

const renderContinueBtn = function (window) {
  const markup = `  <br>
  <button class="btn upload__btn      upload-supply-input__btn">
  <span>Continua</span>
  </button>`;

  window.insertAdjacentHTML("beforeend", markup);
};

const checkContinueBtn = function (continueBtn, typeInput) {
  continueBtn.addEventListener("click", function (e) {
    e.preventDefault();
    checkInputValues(typeInput);
  });
};

const checkInputValues = function (typeInput) {
  if (typeInput === "supplyValues") readSupplyTableValues();
  if (typeInput === "UfSupplyValues") readBasicSupplyTableValues();
  if (typeInput === "fertiPlan") readFertiPlanTableValues();
};

export const findSelectedSector = function (
  originalSectorRows,
  selectedSectorId,
) {
  const selectedSectorRow = originalSectorRows.find(
    (sector) => sector.sectorId === selectedSectorId,
  );
  return selectedSectorRow;
};

export const findSelectedCrop = function (originalCropRows, selectedCropId) {
  const selectedCropRow = originalCropRows.find(
    (crop) => crop.cropId === selectedCropId,
  );
  return selectedCropRow;
};

export const findSelectedProduct = function (
  originalProductRows,
  selectedProductId,
) {
  const selectedProductRow = originalProductRows.find(
    (prod) => prod.productId === selectedProductId,
  );
  return selectedProductRow;
};

export const renderPlanRecap = async function (planId, window, account) {
  console.log(planId);

  //Update OriginalXRows
  originalCompanyRows = await companyRowsValid();
  originalPlanRows = await planRowsValid(planRows);
  originalCropRows = await cropRowsValid();
  originalSectorRows = await sectorRowsValid();
  originalFertiProductRows = await fertiProductRowsValid();
  originalProductRows = await productRowsValid();

  //Get data for titleRecapTable and companySectorRecapTable

  console.log(planId);
  let planDescription,
    planDate,
    companyId,
    cropId,
    sectorId,
    sectorAreaHa,
    totPressionTime,
    emptyCleanTime;
  console.log("OriginalPLanRows: ", originalPlanRows);
  originalPlanRows.forEach((plan) => {
    if (plan.planId === planId) {
      console.log(plan);
      planDescription = plan.planName;
      //Get and format date
      const date = new Date(plan.date).toISOString();
      console.log(date);
      const day = date.slice(8, 10);
      console.log(day);
      const month = date.slice(5, 7); // Month is 0-indexed
      const year = date.slice(0, 4);

      planDate = `${day}/${month}/${year}`;
      companyId = plan.companyId;
      cropId = plan.cropId;
      sectorId = plan.sectorId;
      sectorAreaHa = plan.sectorAreaHa;
      totPressionTime = plan.totPressionTime;
      emptyCleanTime = plan.emptyCleanTime;
    }
  });
  console.log(companyId, cropId, sectorId);

  let companyName, street, city, province, country;
  originalCompanyRows.forEach((company) => {
    if (company.companyId === companyId) {
      companyName = company.company;
      street = company.address.street;
      city = company.address.city;
      province = company.address.province;
      country = company.address.country;
    }
  });

  let cropName;
  originalCropRows.forEach((crop) => {
    if (crop.cropId === cropId) {
      cropName = crop.crop;
    }
  });

  let sectorName;
  originalSectorRows.forEach((sector) => {
    if (sector.sectorId === sectorId) {
      sectorName = sector.name;
    }
  });

  //Get data for FertiPlanRecapTable
  const markupFertiPeriods = ``;

  let currPlan;
  originalPlanRows.forEach((plan) => {
    if (plan.planId === planId) {
      console.log(plan);
      currPlan = plan;
    }
  });

  console.log("currPlan", currPlan);
  const maxPhase = currPlan.fertiPlanTotData.length;
  console.log(maxPhase);

  let markupFertiPeriod = "";
  for (let phase = 1; phase <= maxPhase; phase++) {
    console.log(phase);

    const productHeader = `<tr><td class='headerh'>PRODOTTO</td>
              <td class='headerh'>DOSE PER INTERVENTO A ETTARO</td><td class='headerh'>DOSE PER INTERVENTO A SETTORE</td></tr>`;

    let period, intNum;
    let productMarkup = "";
    currPlan.fertiPlanData.forEach((phaseData) => {
      if (phaseData.phase === phase) {
        period = phaseData.period;
        intNum = phaseData.intNum;
        const productId = phaseData.productId;

        //Find measurement unit
        let solubilCoeff;
        originalFertiProductRows.forEach((product) => {
          if (product.productId === productId) {
            solubilCoeff = product.solubilCoeff;
          }
        });
        let um;
        if (solubilCoeff === 1) um = "l";
        if (solubilCoeff < 1) um = "kg";
        console.log(phaseData, phaseData.product);

        const supplySector = phaseData.supply * sectorAreaHa;

        console.log("CHECK FERTI PROD", phaseData.product);
        productMarkup =
          productMarkup +
          `<tr><td>${phaseData.product}</td>
              <td>${
                phaseData.supply
              } ${um}</td><td>${supplySector} ${um}</td></tr>`;
      }
    });

    let waterVol,
      motherSolVol,
      waterSupplyMmHa,
      maxWaterVolSector,
      maxFertiTime,
      totIrrigatTime;
    currPlan.fertiPlanTotData.forEach((phaseTotData) => {
      if (phaseTotData.phase === phase) {
        waterVol = phaseTotData.waterVol.toFixed(2);
        motherSolVol = phaseTotData.motherSolVol;
        waterSupplyMmHa = phaseTotData.waterSupplyMmHa;
        maxWaterVolSector = phaseTotData.maxWaterVolSector;
        maxFertiTime = phaseTotData.maxFertiTime;
        totIrrigatTime = phaseTotData.totIrrigatTime;
        console.log(waterVol);
      }
    });
    console.log(waterVol);

    markupFertiPeriod =
      markupFertiPeriod +
      `<tr></tr>
      <td><h3 class='ferti-sub-title'>FERTIRRIGAZIONE ${phase}</h3>
              Fase Fenologica - Periodo: ${period}<br>
              <strong>Numero Interventi: ${intNum}</strong><br>
              Volume d'acqua pura in cui sciogliere i prodotti per intervento (l): ${waterVol}<br>
              Volume soluzione finale per intervento (l): ${motherSolVol}<br>
              Volume d'acqua da apportare per intervento (mm/ha): ${waterSupplyMmHa}<br>
              Volume di adacquamento (mc): ${maxWaterVolSector}<br>
              <strong>Tempo di fertiniezione (min): ${maxFertiTime}</strong><br>
              <strong>Tempo totale di fertirrigazione (min):  ${totIrrigatTime}</strong><br>
              <table class='products-recap-table'>
              ${productHeader}
              ${productMarkup}
              </table>

              </td>
              </tr>`;
  }

  //Get data for baseRecapTable
  let markupBase = "";
  let period, productId;
  let haQuantity = 0;
  let sectorQuantity = 0;
  if (currPlan.ufBaseSupply.length !== 0) {
    currPlan.ufBaseSupply.forEach((ufBase) => {
      period = ufBase.period;
      productId = ufBase.ufProduct;
      haQuantity = Number(ufBase.haQuantity).toFixed(2);
      sectorQuantity = Number(ufBase.sectorQuantity).toFixed(2);
      console.log(ufBase.ufProduct);

      let productName;
      originalProductRows.forEach((product) => {
        if (product.productId === productId) {
          productName = product.product;
          console.log(productName);
        }
      });

      markupBase =
        markupBase +
        `<tr>
      <td>${period}
      </td>
      <td> ${productName}
      </td>
      <td>${haQuantity}
      </td>
      <td>${sectorQuantity}
      </td>
      </tr>
          `;
    });
  }
  if (currPlan.ufBaseSupply.length === 0) {
    markupBase = `<tr>
      <td>-
      </td>
      <td>-
      </td>
      <td>-
      </td>
      <td>-
      </td>
      </tr>
          `;
  }

  //Get data for ufRecapTable

  const ufHeader = headerCrop.slice(2);
  console.log(ufHeader);
  console.log(currPlan);

  //Check if currPlan.ufBaseSupplyPerHa !== 0
  const ufBaseValues = Object.values(currPlan.ufBaseSupplyPerHa);
  console.log(ufBaseValues);
  const checkBaseValues = ufBaseValues.some((value) => value !== 0);
  console.log(checkBaseValues);

  let markupUf = ``;

  for (let index = 0; index < ufHeader.length; index++) {
    const key = `count${ufHeader[index]}`;

    let totSupply;
    let deltaSupply;
    if (checkBaseValues) {
      totSupply =
        Number(currPlan.ufBaseSupplyPerHa[key]) +
        Number(currPlan.totPlanSupply[index]);
      console.log(
        totSupply,
        currPlan.ufBaseSupplyPerHa[key],
        currPlan.totPlanSupply[index],
      );
      deltaSupply = Number(currPlan.deltaFertiSupply[index]);
    }
    if (!checkBaseValues) {
      totSupply = Number(currPlan.totPlanSupply[index]);
      console.log(totSupply, currPlan.totPlanSupply[index]);
      deltaSupply = Number(currPlan.deltaFertiSupply[index]);
    }
    console.log(deltaSupply);

    let basePerc = 0;
    let fertiPerc = 0;
    let totPerc = 0;
    if (totSupply !== 0) {
      basePerc = ((currPlan.ufBaseSupplyPerHa[key] / totSupply) * 100).toFixed(
        1,
      );

      fertiPerc = ((currPlan.totPlanSupply[index] / totSupply) * 100).toFixed(
        1,
      );

      totPerc = ((totSupply / (totSupply + deltaSupply)) * 100).toFixed(1);
    }

    if (checkBaseValues) {
      markupUf =
        markupUf +
        `<tr>
    <td class='header'>${ufHeader[index]} 
    </td>
    <td>${currPlan.ufBaseSupplyPerHa[key]} (${basePerc}%)
    </td>
    <td>${currPlan.totPlanSupply[index]} (${fertiPerc}%)
    </td>
    <td class="tot-planned">${totSupply.toFixed(1)} (${totPerc}%)
    </td>
    <td>${currPlan.supplyProgram[key]}
    </td>
    </tr>
        `;
    }
    if (!checkBaseValues) {
      markupUf =
        markupUf +
        `<tr>
    <td class='header'>${ufHeader[index]} 
    </td>
    <td>0 (0%)
    </td>
    <td>${currPlan.totPlanSupply[index]} (${fertiPerc}%)
    </td>
    <td class="tot-planned">${totSupply.toFixed(1)} (${totPerc}%)
    </td>
    <td>${currPlan.supplyProgram[key]}
    </td>
    </tr>
        `;
    }
  }

  //COST
  //Check if all ferti phase cost are valid test
  let validCost = [];
  currPlan.fertiPlanTotData.forEach((phaseTotData) => {
    if (phaseTotData.totCostHa !== 0) {
      validCost.push(phaseTotData.phase);
    }
  });
  console.log(validCost);
  //All ferti phase costs are valid
  let fertiTotCostHa = 0;
  let fertiTotCostSector = 0;
  if (validCost.length === currPlan.fertiPlanTotData.length) {
    currPlan.fertiPlanTotData.forEach((phaseTotData) => {
      fertiTotCostHa = Number(fertiTotCostHa) + Number(phaseTotData.totCostHa);
      fertiTotCostSector =
        Number(fertiTotCostSector) + Number(phaseTotData.totCostSector);
    });
    console.log(fertiTotCostHa, fertiTotCostSector);
  }
  if (validCost.length !== currPlan.fertiPlanTotData.length) {
    fertiTotCostHa = "-";
    fertiTotCostSector = "-";
  }

  let baseCostHa = "-";
  if (
    currPlan.ufBaseSupply.length !== 0 &&
    currPlan.ufBaseTotHaCost &&
    currPlan.ufBaseTotHaCost !== 0
  )
    baseCostHa = currPlan.ufBaseTotHaCost;
  if (
    currPlan.ufBaseSupply.length !== 0 &&
    currPlan.ufBaseTotHaCost &&
    currPlan.ufBaseTotHaCost === 0
  )
    baseCostHa = "-";

  if (currPlan.ufBaseSupply.length === 0) baseCostHa = 0;
  console.log(baseCostHa);

  let baseCostSector = "-";
  if (
    currPlan.ufBaseSupply.length !== 0 &&
    currPlan.ufBaseTotSectorCost &&
    currPlan.ufBaseTotSectorCost !== 0
  )
    baseCostSector = currPlan.ufBaseTotSectorCost;
  if (
    currPlan.ufBaseSupply.length !== 0 &&
    currPlan.ufBaseTotSectorCost &&
    currPlan.ufBaseTotSectorCost === 0
  )
    baseCostSector = "-";

  if (currPlan.ufBaseSupply.length === 0) baseCostSector = 0;
  console.log(baseCostSector);

  let totCostHa = "-";
  let totCostSector = "-";
  if (fertiTotCostHa !== "-" && baseCostHa !== "-") {
    totCostHa = Number(baseCostHa) + Number(fertiTotCostHa);
    totCostSector = Number(baseCostSector) + Number(fertiTotCostSector);
  }

  const markupCost = `<tr>
      <td class='header'>Concimi di fondo 
      </td>
      <td>${baseCostHa}
      </td>
      <td>${baseCostSector}
      </td>
    </tr>
    <tr>
      <td class='header'>Fertirriganti 
      </td>
      <td>${fertiTotCostHa}
      </td>
      <td>${fertiTotCostSector}
      </td>
    </tr>
    <tr>
      <td class='header'>TOTALE
      </td>
      <td>${totCostHa}
      </td>
      <td>${totCostSector}
      </td>
    </tr>`;

  const markupRecapTable = `<table class="ref-recap-table">
    <tr>
            
              <td id='logo-cell'>
              <div class="logo-flex">
              <img src="/icons/logo-leave-water.jfif" alt="Logo" class="logo" /> <span class="logo-span">AgriFertify</span></div></td>
              <td>Referente: ${
                account.display_name || account.description || "N/A"
              }<br>
              cell: ${account.phone_number || account.cell || "N/A"}<br>
              email: ${account.email}</td>
    </tr>
   
  </table>
  <table class="title-recap-table">
    <tr>
              <td id='plan-title'>PIANO ${planDescription} del ${planDate}</td>
    </tr>
  </table>
  <table class="company-sector-recap-table">
  <tr class='sub-title'><td>RIEPILOGO DATI AZIENDA - SETTORE
    </td></tr>
    <tr>
              <td><h3 class='company-sub-title'>AZIENDA: </h3>
              Nome: ${companyName}<br>
              Indirizzo: ${street}, ${city}, ${province}, ${country}</td>
    </tr>
    <tr>
              <td><h3 class='company-sub-title'>SETTORE:</h3> 
              Descrizione: ${sectorName}<br>
              Coltura: ${cropName}<br>
              Superficie (ha): ${sectorAreaHa}<br>
              <strong>Tempo di messa in pressione impianto (min): ${totPressionTime}</strong><br>
              <strong>Tempo svuotamento e lavaggio impianto(min): ${emptyCleanTime}</strong><br>
              </td>
    </tr>
  </table>
  <table class="base-recap-table">
  <tr><td class='sub-title'>PROGRAMMA CONCIMAZIONE DI FONDO
    </td></tr>
    <tr>
    <table class="base-recap-table-data">
    <tr>
      <td class='headerh'>FASE FENOLOGICA - PERIODO</td>
      <td class='headerh'>PRODOTTO</td>
      <td class='headerh'>kg/ha</td>
      <td class='headerh'>kg/sett.</td>
    </tr>
    <tr>
              ${markupBase}
    </tr>
    </table></tr>
  </table>
  <table class="ferti-plan-recap-table">
    <tr>
              <td class='sub-title'>PROGRAMMA FERTIRRIGAZIONE</td>
    </tr>
    <tr>
              ${markupFertiPeriod}
    </tr>
  </table>
  
  <table class="uf-recap-table">
  <tr><td class='sub-title'>APPORTO UNITA' FERTILIZZANTI
    </td></tr>
    <table class="uf-recap-table-data">
    <tr>
            <td class='headerh'>TITOLI</td>
            <td class='headerh'>CONCIME BASE <br>(% sul Tot. Programmato)</td>
            <td class='headerh'>PRODOTTI FERTIRRIGAZ. <br>(% sul Tot. Programmato)</td>
            <td class='headerh'>TOTALE PROGRAMMATO(UF/ha) <br>(% sul Tot. da Programmare)</td>
            <td class='headerh'>TOTALE DA PROGRAMMARE(UF/ha)</td>
    </tr>
    <tr>
              ${markupUf}
    </tr>
    </table>
  </table>
  <table class="cost-recap-table">
  <tr><td class='sub-title'>RIEPILOGO COSTI</td>
    </tr>
    <table class="cost-recap-table-data">
    <tr>
            <td class='headerh'>TIPOLOGIA PRODOTTI</td>
            <td class='headerh'>COSTO PER ETTARO (€/ha)</td>
            <td class='headerh'>COSTO PER SETTORE (€/settore)</td>
            
    </tr>
    <tr>
              ${markupCost}
    </tr>
    </table>
  </table>`;

  const markupPdfBtns = `<nav class='open-plan-nav'>
    <button class="btn print-pdf-plan-cost_btn">
      <span>Stampa PDF completo</span>
    </button>
    <button class="btn print-pdf-plan_btn">
      <span>Stampa PDF senza Costi</span>
    </button>
  </nav>`;

  window.insertAdjacentHTML("afterbegin", markupRecapTable);
  window.insertAdjacentHTML("beforeend", markupPdfBtns);

  const printCostPdfBtn = document.querySelector(".print-pdf-plan-cost_btn");
  const printPdfBtn = document.querySelector(".print-pdf-plan_btn");

  printCostPdfBtn.addEventListener("click", function () {
    console.log("printPdfBtn with costs clicked");

    printPdfCost();
  });

  printPdfBtn.addEventListener("click", function () {
    console.log("printPdfBtn without costs clicked");

    printPdf();
  });
};

const printPdfCost = async function () {
  console.log("printing pdf with cost");
  const element = document.querySelector(".ref-recap-table").closest("div");

  const costTable = element.querySelector(".cost-recap-table");
  const costTableData = element.querySelector(".cost-recap-table-data");

  // Hide cost table and navigation buttons
  if (costTable) {
    costTable.style.display = "";
  }
  if (costTableData) {
    costTableData.style.display = "";
  }

  // Hide navigation buttons before printing
  const navButtons = element.querySelector(".open-plan-nav");
  if (navButtons) {
    navButtons.style.display = "none";
  }

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: true,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Define margins (in mm)
    const margin = 15;

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", margin, margin, pdfWidth, pdfHeight);

    // If content is longer than one page, add new pages
    const pageHeight = pdf.internal.pageSize.getHeight();
    if (pdfHeight > pageHeight - 2 * margin) {
      const totalPages = Math.ceil((pdfHeight + 2 * margin) / pageHeight);
      for (let i = 1; i < totalPages; i++) {
        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          margin,
          margin - pageHeight * i,
          pdfWidth,
          pdfHeight,
        );
      }
    }

    pdf.save("piano_fertirrigazione.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    // Restore navigation buttons visibility
    if (navButtons) {
      navButtons.style.display = "";
    }
  }
};

const printPdf = async function () {
  const element = document.querySelector(".ref-recap-table").parentElement;
  const costTable = element.querySelector(".cost-recap-table");
  const costTableData = element.querySelector(".cost-recap-table-data");
  const navButtons = element.querySelector(".open-plan-nav");

  // Hide cost table and navigation buttons
  if (costTable) {
    costTable.style.display = "none";
  }
  if (costTableData) {
    costTableData.style.display = "none";
  }
  if (navButtons) {
    navButtons.style.display = "none";
  }

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: true,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Define margins (in mm)
    const margin = 15;

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", margin, margin, pdfWidth, pdfHeight);

    // If content is longer than one page, add new pages
    const pageHeight = pdf.internal.pageSize.getHeight();
    if (pdfHeight > pageHeight - 2 * margin) {
      const totalPages = Math.ceil((pdfHeight + 2 * margin) / pageHeight);
      for (let i = 1; i < totalPages; i++) {
        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          margin,
          margin - pageHeight * i,
          pdfWidth,
          pdfHeight,
        );
      }
    }

    pdf.save("piano_fertirrigazione_no_costi.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    // Restore cost table and navigation buttons visibility
    if (costTable) {
      costTable.style.display = "";
    }
    if (navButtons) {
      navButtons.style.display = "";
    }
  }
};

const updateOriginalRows = async function () {
  //Update OriginalXRows
  originalCompanyRows = await companyRowsValid();
  originalPlanRows = await planRowsValid(planRows);
  originalCropRows = await cropRowsValid();
  originalSectorRows = await sectorRowsValid();
  originalFertiProductRows = await fertiProductRowsValid();
  originalProductRows = await productRowsValid();
  return originalPlanRows;
};
